import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import barGraphImage from '../../../src/assets/images/public-bar-graph.png';
import lineGraphImage from '../../../src/assets/images/public-line-graph.png';
import bgMobile from '../../../src/assets/images/mobile-bg.png';
import QLogo from '../../../src/assets/images/quattr_logo_transperent.png';
import Router from 'next/router';

export default function AuthLayout(props) {
  const [isMobile, setMobile] = useState(null);

  React.useEffect(() => {
    const isMobile = document.documentElement.clientWidth < 768;
    if (isMobile) {
      setMobile(isMobile);
    }
  }, []);

  return (
    <Grid id="layout__grid__auth_layout_0" container className="auth-page-container">
      {!props.hideIcon && (
        <img onClick={() => Router.push('/')} src={QLogo.src} alt="Quattr logo" className="Q-logo"></img>
      )}
      <Grid id="layout__grid__auth_layout_1" item sm={6} xs={12} className={`content-wrapper ${props.className || ''}`}>
        {props.children}
      </Grid>
      <Grid id="layout__grid__auth_layout_2" item sm={6} xs={undefined} className="background-img background-design">
        {isMobile ? (
          <img src={bgMobile.src} />
        ) : (
          <div className="trangles">
            <div className="trangle-big">
              <div className="image-1">
                {props.text ? <span>{props.text}</span> : <img src={barGraphImage.src} alt="Bar graph icon" />}
              </div>
              <div className="shadow-image-1"></div>
              <div className="image-2">
                {props.text ? <span>{props.text}</span> : <img src={lineGraphImage.src} alt="Line graph icon" />}
              </div>
              <div className="shadow-image-2"></div>
            </div>
            <div className="trangle-small"></div>
          </div>
        )}
      </Grid>
    </Grid>
  );
}
